import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringLengthExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";

export class StringLengthExpressionEditor extends ExpressionRuleEditor<StringLengthExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <ExpressionPiece>length</ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                </ExpressionPiece>
            </>
        );
    }
}
